{
  "search-join-attendee-submit-btn": "DONE",
  "go-to-package-btn": "Purchase Options",
  "done-exit-btn": "Done (Exit Kiosk)",
  "title-select-package": "Select a Package",
  "title-suggest-a-product": "Would you like to add another product to your order?",
  "title-choose-a-product": "Pick a product to add to your order",
  "title-shopping-cart": "Shopping Cart",
  "select-images-notice-message": "Please select images you want to print.",
  "select-images-notice-ok": "OK",
  "confirm-change-img-btn": "OK, Use this image"
}
